module.exports = __webpack_public_path__ + "static/HOOU-Logo-1cabc85a69a61242861ad2fdabaa5eb5.svg";